/**
 * フリガナ欄: 半角カナ等を NFKC で全角寄せにする（ｱ → ア など）
 */
export function furiganaToFullWidth(str) {
  return String(str ?? '').normalize('NFKC');
}

/**
 * 氏名フリガナ向け: NFKC のあとひらがなをカタカナに（カタカナ欄の統一）
 */
export function toFullWidthKatakana(str) {
  const n = furiganaToFullWidth(str);
  let out = '';
  for (const ch of n) {
    const c = ch.charCodeAt(0);
    if (c >= 0x3041 && c <= 0x3096) {
      out += String.fromCharCode(c + 0x60);
    } else {
      out += ch;
    }
  }
  return out;
}
